export const BOX_STYLE = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: 344,
  padding: '12px 24px',
  margin: 24,
  overflowX: 'hidden',
  overflowY: 'overlay',
  outline: 'none',
  maxHeight: '94%',
  boxSizing: 'border-box',
  backgroundColor: 'rgb(255, 255, 255)',
  fontFamily: '"Fira Sans", sans-serif',
  zIndex: 1
};
